/* tslint:disable */
/* eslint-disable */
/**
 * Finastic Frontend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InitiateResetPasswordWithOtpCommand
 */
export interface InitiateResetPasswordWithOtpCommand {
    /**
     * 
     * @type {string}
     * @memberof InitiateResetPasswordWithOtpCommand
     */
    phoneNumber: string;
}

export function InitiateResetPasswordWithOtpCommandFromJSON(json: any): InitiateResetPasswordWithOtpCommand {
    return InitiateResetPasswordWithOtpCommandFromJSONTyped(json, false);
}

export function InitiateResetPasswordWithOtpCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InitiateResetPasswordWithOtpCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'phoneNumber': json['phoneNumber'],
    };
}

export function InitiateResetPasswordWithOtpCommandToJSON(value?: InitiateResetPasswordWithOtpCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'phoneNumber': value.phoneNumber,
    };
}

